import { documentsQueryKeys } from '@src/documents/queryKeys';
import { DocumentsClient } from '@src/documents/services/DocumentsClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useMarkToSendDocument = ({
  orderId,
}: {
  orderId?: string;
} = {}) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async (data: { documentId: string; sendToClient: boolean }) => {
      await DocumentsClient.markToSend(data.documentId, data.sendToClient);
      return data;
    },
    onSuccess: async () => {
      if (orderId) {
        await queryClient.invalidateQueries({
          queryKey: documentsQueryKeys.byOrderId(orderId),
        });
      }
    },
  });

  return {
    markToSend: mutate,
    isPending,
  };
};
